import axios from '../utils/axios';

export default function updateSeekerEmailStatus (adminId, data) {
    return axios.post(`/admin/${adminId}/jobseeker-admin/user/admin/change-email-status`, data);
}